import { render } from "./Contact.vue?vue&type=template&id=3ff2460b&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=3ff2460b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff2460b"]])

export default __exports__